module.exports = __webpack_public_path__ + "img/57.a86eea17.png";